import React from "react";
import { GovernyInfo } from "../../../../lib/types";
import ArmyUnitAttributeLine from "../Army/ArmyUnitAttributeLine";

import { portraits } from "../../../../assets/images/races";
import GovernorateInfoLink from "../../../Common/GovernorateInfoLink";

interface IProps {
  ally: boolean;
  position: string;
  virtual: boolean;
  governorate?: GovernyInfo;
  stats?: string[];
}

const NewsPersonBanner = ({
  position,
  virtual,
  governorate,
  stats
}: IProps) => (
  <div className={`person no-hover`} style={virtual
    ? {
      marginTop: 0,
      marginBottom: 0,
      borderColor: "#e62f2f"
    }
    : {
      marginTop: 0,
      marginBottom: 0
    }}>
    {<h4 className="subname h3">{virtual ? <span className={"negative"}>&nbsp;PASSIVE</span> : position.toUpperCase()}</h4>}
    {governorate
      ? <>
        <img src={portraits[governorate.race.name]} alt="" className="photo"/>
        <p>
          <GovernorateInfoLink
            govId={governorate.id}
            name={governorate.name}
            raceName={governorate.race.name}
          />
        </p>
      </>
      : <>
        <i className="icon-banner icon-xlg icon middle" style={{ height: "50px", width: "50px", marginBottom: "25px" }}/>
      </>
    }
    <ArmyUnitAttributeLine
      attributes={[
        {
          icon: "utok",
          title: "Attack",
          content: "attack power, ability to hit",
          value: (stats && stats[0]) || "-"
        },
        {
          icon: "obrana",
          title: "Defence",
          content: "defense power, ability to block hits",
          value: (stats && stats[1]) || "-"
        },
        {
          icon: "piercing",
          title: "Piercing",
          content: "ability to overcome armor",
          value: (stats && stats[2]) || "-"
        },
        {
          icon: "armor",
          title: "Armor",
          content: "reduces damage by 25% unless it’s pierced",
          value: (stats && stats[3]) || "-"
        }
      ]}
    />
    <ArmyUnitAttributeLine
      attributes={[
        {
          icon: "ranged-attack",
          title: "Ranged Attack",
          content: "ranged attack power, ability to hit targets in range phase",
          value: (stats && stats[5]) || "-"
        },
        {
          icon: "range",
          title: "Range",
          content: "distance from which the unit engages in range phase",
          value: (stats && stats[4]) || "-"
        },
        {
          icon: "dalsi-tah-5",
          title: "Charge",
          content: "force of initial attack",
          value: (stats && stats[5]) || "-"
        },
        {
          icon: "dalsi-tah-6",
          title: "Speed",
          content: "adaptability and mobility of unit",
          value: (stats && stats[6]) || "-"
        }
      ]}
    />
    <ArmyUnitAttributeLine
      attributes={[
        {
          icon: "totem",
          title: "Stamina",
          content: "endurance of unit during the battle",
          value: (stats && stats[7]) || "-"
        },
        {
          icon: "armada",
          title: "Morale",
          content: "mental resistance to damage",
          value: (stats && stats[8]) || "-"
        },
        {
          icon: "hit-points",
          title: "Hit Points",
          content: "hit points, physical resistance to damage",
          value: (stats && stats[9]) || "-"
        }
      ]}
    />
  </div>
)

export default NewsPersonBanner;
